import { TFilterResult } from 'types/shared';

interface ISortableByMetric {
  values: { [key: string]: number };
}

/**
 * Returns a function to be used by Array.sort to sort
 * a list of objects that contain values with multiple
 * metrics. The list will be sorted descending by the
 * given smetric name
 * @param metric the name of the metric by which the list must be sorted
 */
export function sortByMetric(
  metric: string
): (first: any, second: any) => number {
  return function (
    first: ISortableByMetric,
    second: ISortableByMetric
  ): number {
    return second.values[metric] - first.values[metric]; // descending
  };
}

interface IHasBreakDown {
  breakdown: any;
}

/**
 * Returns a function to be used by Array.filter to filter
 * a list of objects by the specified breakdown value.
 * @param allowedValues
 */
export function filterByValues(
  allowedValues: any[]
): TFilterResult<IHasBreakDown> {
  return function (breakdown: IHasBreakDown): boolean {
    return allowedValues.includes(breakdown.breakdown);
  };
}
